<template>
	<div class="container">
		<el-card>
			<div slot="header">售水查询</div>
			<div style="height: 100%">
				<el-button type="primary" @click="addSellWater" icon="el-icon-plus">新增售水</el-button>
				<!-- <el-button
          type="primary"
          @click="addCancelWater"
          style="background-color: #1c84c6 !important"
          >新增退水</el-button
        > -->
				<!-- <el-button type="primary" style="background-color: #1abc9c !important"
          >查看详细</el-button
        > -->
				<el-button type="primary" class="iconfont icon-excel" style="background-color: #23c6c8 !important"
					@click="exportToExcel">
					导出</el-button>
				<el-button type="primary" @click="downloadPayPaper" icon="el-icon-printer">打印收款凭证</el-button>
				<el-checkbox v-model="printMerge" style="margin-left: 10px" label="合并打印收款凭证"></el-checkbox>
				<el-form ref="form" :model="form" label-width="80px" size="small" style="margin-top: 15px">
					<el-form-item label="创建时间" label-width="70px">
						<el-date-picker v-model="queryParams.createStartTime" type="datetime" placeholder="选择开始日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
						<label> 到 </label>
						<el-date-picker v-model="queryParams.createEndTime" type="datetime" placeholder="选择结束日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="订单号">
						<el-input v-model="queryParams.orderNo" style="width: 150px;" placeholder="" id="collectAmount"
							clearable @keyup.enter.native="handleQuery(true)">
						</el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-select v-model="queryParams.lesseeId" placeholder="" size="small" clearable filterable
							class="searchTag" style="width: 150px;">
							<el-option v-for="item in merchantNameOptions" :key="item.key" :label="item.value"
								:value="item.key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="线上线下">
						<el-select v-model="queryParams.onlineOffline" placeholder="请选择" clearable filterable
							class="searchTag" style="width: 80px;">
							<el-option v-for="item in onlineOption" :key="item.key" :label="item.value"
								:value="item.key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="付款方式">
						<el-select v-model="queryParams.payType" placeholder="请选择" clearable filterable
							class="searchTag" style="width: 100px;">
							<el-option v-for="item in payTypeOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="订单状态">
						<el-select v-model="queryParams.state" placeholder="请选择" clearable style="">
							<el-option v-for="item in payOrderStateOption" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="区域" label-width="70px">
						<el-cascader v-model="queryParams.districtId" :options="districtIdOptions" :props="props"
							clearable style="width: 150px;"></el-cascader>
					</el-form-item>
					<el-button type="primary" size="small" style="margin-left: 10px" icon="el-icon-search"
						@click="handleQuery(true)">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table :data="tableData" style="width: 100%" height="92%" id="sellWaterRecord"
						ref="sellWaterRecord" @row-click="handleRowClick" @selection-change="handleCurrentChange">
						<el-table-column type="selection" width="50" align="center">
						</el-table-column>
						<el-table-column type="index" width="60" align="center" label="序号" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" width="180" align="center">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" width="150" align="center">
						</el-table-column>
						<el-table-column prop="orderNo" label="订单号" width="160" align="center">
						</el-table-column>
						<el-table-column prop="lesseeCode" label="商户编号" width="150" align="center">
						</el-table-column>
						<el-table-column prop="lesseeName" label="商户名称" width="150" align="center">
						</el-table-column>
						<el-table-column prop="money" label="售水金额(元)" width="150" align="center">
						</el-table-column>
						<el-table-column prop="balance" label="余额(元)" width="150" align="center">
						</el-table-column>
						<el-table-column prop="payType" label="付款方式" width="150" align="center">
						</el-table-column>
						<el-table-column prop="districtName" label="区域名称" width="150" align="center">
						</el-table-column>
						<el-table-column prop="onlineOffline" label="线上线下" width="150" align="center">
						</el-table-column>
						<el-table-column prop="lesseeType" label="商户业态" width="150" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		translateObjectEmptyAttributeToNull,
		cascaderAfferentString,
		cascaderAfferentNumber,
	} from '../../untils/func';
	import {
		selectList
	} from '../../api/water/sellWaterRecord';
	import {
		selectLessee,
		selectDictionaryListByName,
		selectComboboxTreeData,
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import exportTable from '../../untils/exportTable';
	export default {
		data() {
			return {
				form: {},
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
				},
				tableData: [],
				// 遮罩层
				loading: true,
				total: 0,
				currentRow: null,
				merchantNameOptions: [],
				onlineOption: [],
				payTypeOptions: [],
				// 订单状态下拉框
				payOrderStateOption: [],
				multipleSelection: [],
				printMerge: false,
				scrollTop: null,
				districtIdOptions: [], // 区域 options
				props: {
					expandTrigger: 'hover',
				},
			};
		},
		created() {
			this.init();
		},
		mounted() {
			this.$nextTick(() => {
				this.$refs.sellWaterRecord.bodyWrapper.addEventListener('scroll', (res) => {
					this.scrollTop = res.target.scrollTop;
				}, false)
			});
		},
		beforeDestroy() {
			this.$refs.sellWaterRecord.bodyWrapper.addEventListener('scroll', (res) => {
				this.scrollTop = res.target.scrollTop;
			}, false)
		},

		watch: {
			$route(to) {
				if (to.path == '/mainWindow/sellWaterRecord') {
					this.getScroll()
				}
			},
		},
		methods: {
			getScroll() {
				let that = this;
				this.$nextTick(() => {
					setTimeout(() => {
						let scroll = that.$el.querySelector('.el-table__body-wrapper');
						console.log(that.scrollTop)
						scroll.scrollTop = that.scrollTop;
					}, 10)
				});
			},
			async init() {
				await this.handleQuery();
				await this.getSelectLessee();
				await this.getOnlineOffline();
				await this.getPayType();
				await this.getPayOrderState();
				await this.selectComboboxTreeData();
			},
			async handleQuery(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParams.current = 1;
				}
				this.loading = true;
				let param = JSON.parse(JSON.stringify(this.queryParams));
				if (param.districtId == 0){
					param.districtId = null;
				}
				if (param.districtId != null) {
					if (param.districtId.constructor === Array) {
						param.districtData = cascaderAfferentString(param.districtId);
						param.districtId = cascaderAfferentNumber(param.districtId);
					}
				}
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				this.total = response.total;
				this.loading = false;
			},
			// 区域下拉框
			async selectComboboxTreeData() {
				const res = await selectComboboxTreeData().then();
				this.districtIdOptions = res.data;
			},
			//点击行触发，选中或不选中复选框
			handleRowClick(row) {
				this.$refs.sellWaterRecord.toggleRowSelection(row);
			},
			addSellWater() {
				this.$router.push({
					path: '/mainWindow/addSellWater',
				});
			},
			addCancelWater() {
				this.$router.push({
					path: '/mainWindow/cancelSellWater',
				});
			},

			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('sellWaterRecord', '售水记录');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			// 获取下拉列表
			async getSelectLessee() {
				// 获取商户下拉列表数据
				const res = await selectLessee().then();
				this.merchantNameOptions = res.data;
			},
			// 获取 线上线下 下拉列表
			async getOnlineOffline() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.ONLINE_OFFLINE
				).then();
				this.onlineOption = res.data;
			},
			// 获取付款方式 下拉列表
			async getPayType() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.PAY_TYPE
				).then();
				this.payTypeOptions = res.data;
			},
			// 获取 订单状态 下拉列表
			async getPayOrderState() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.PAY_ORDER_STATE
				).then();
				this.payOrderStateOption = res.data;
			},
			// 单选表格某一行
			handleCurrentChange(val) {
				this.multipleSelection = val;
			},
			// 下载收款凭证
			async downloadPayPaper() {
				if (this.multipleSelection == []) {
					this.$message.error('请先选择某条数据！');
				} else {
					let params = [];
					this.multipleSelection.forEach((item) => {
						params.push(item.orderNo);
					});
					var path;
					// 是否合并打印收款凭证
					if (this.printMerge) {
						path = '/printViewWaterMerge';
					} else {
						path = '/PrintViewWater';
					}
					let routeData = this.$router.resolve({
						path: path,
						query: {
							multipleSelection: JSON.stringify(params),
							serviceFeeColumnName: this.$root.serviceFeeNameWater
						},
					});
					window.open(routeData.href, '_blank');
				}
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
		margin-bottom: 10px;
	}

	.searchTag {
		width: 182px;
	}

	.tableStyle {
		height: calc(100% - 84px);
	}

	.block {
		margin-top: 10px;
	}
</style>
